import React from 'react';

const Card = ({ imageSrc, title, listItems }) => {
  return (
    <div className="bg-white px-8 py-8 rounded-2xl shadow-md border border-[#D4D2E3]">
      <img src={imageSrc} alt="" className="h-28 smallScreens:mx-auto" />
      <div className="flex items-center mb-4">
        <h3 className="text-[#191825] text-[2rem] ml-4 font-bold">
          {title}
        </h3>
      </div>
      <ul className="list-decimal list-inside text-[1.6rem] text-[#6A6A6A] space-y-6">
        {listItems.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};
export default Card